'use client';

import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog';
import { Spinner } from '@/components/ui/spinner';
import React from 'react';

type Props = {
  onClose: () => void;
};

export const Loading: React.FC<Props> = ({ onClose }) => {
  return (
    <Dialog open onOpenChange={(open) => !open && onClose()}>
      <DialogContent>
        <DialogTitle className='sr-only'>Loading</DialogTitle>
        <div className='flex flex-col h-[300px] w-full items-center justify-center'>
          <Spinner className='size-[48px] text-primary-green-day' />
        </div>
      </DialogContent>
    </Dialog>
  );
};
